export default "__VITE_ASSET__DWVO6ZBh__"